import { useState } from 'react';
export function useSendGate() {
    const [isAutoSavePending, setAutoSavePending] = useState(false);
    const [isCustomPageUploading, setCustomPageUploading] = useState(false);
    return {
        isSendBlocked: isAutoSavePending || isCustomPageUploading,
        setAutoSavePending,
        setCustomPageUploading
    };
}
